import gsap from "gsap";
import { disableScroll } from "../helpers/helpers";
import { enableScroll } from "../helpers/helpers";

export default class Modal {
    private timeLine: gsap.core.Timeline;
    private overlay: HTMLElement | null;

    constructor(private modalWrapper: HTMLElement, private close: HTMLElement | null, private readonly activeClass: string) {
        this.timeLine = this.getTimeLine() as gsap.core.Timeline;
        this.overlay = modalWrapper.querySelector(".modal__overlay");
    }

    public init = async () => {
        this.close?.addEventListener("click", this.closeModal);
        this.overlay?.addEventListener("click", this.closeModal);
        document.addEventListener("keyup", (e) => {
            if (e.key === "Escape" || e.keyCode === 27) this.closeModal();
        });
    };

    public openModal = () => {
        const { modalWrapper, activeClass, timeLine } = this;

        modalWrapper.classList.add(activeClass);

        timeLine.play();
        disableScroll();
    };

    private closeModal = () => {
        const { modalWrapper, activeClass } = this;

        this.timeLine.reverse();
        history.pushState("", document.title, window.location.pathname);
        modalWrapper.classList.remove(activeClass);
        enableScroll();
    };

    private getTimeLine = () => {
        const { modalWrapper } = this;
        const content = modalWrapper.querySelector(".modal__modal");

        const tl = gsap.timeline({ paused: true });
        gsap.set(content, { opacity: 0, y: 100 });

        tl.to(modalWrapper, { duration: 0, opacity: 1 });

        tl.to(content, { duration: 0.5, opacity: 1, y: 0 }, "0.3");

        return tl;
    };
}
